import React, { createContext, useState, useEffect } from "react";

export const CartContext = createContext();

export const CartProvider = ({ children = null }) => {
    const [cartItems, setCartItems] = useState([]);
    const [isOpenCart, setIsOpenCart] = useState(false);
    const openCart = () => {
        setIsOpenCart(!isOpenCart);
    }

    useEffect(() => {
        const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
        setCartItems(storedCart);
    }, []);

    const addToCart = (product) => {
        const existingProductIndex = cartItems.findIndex(item => item.uid === product.uid);

        let updatedCart;
        if (existingProductIndex !== -1) {
            updatedCart = cartItems.map(item =>
                item.uid === product.uid
                    ? { ...item, quantity: item.quantity + product.quantity }
                    : item
            );
        } else {
            updatedCart = [...cartItems, product];
        }

        setCartItems(updatedCart);
        localStorage.setItem("cart", JSON.stringify(updatedCart));
    };

    const updateQuantity = (productId, quantity) => {
        const updatedCart = cartItems.map(item =>
            item.uid === productId ? { ...item, quantity } : item
        );
        setCartItems(updatedCart);
        localStorage.setItem("cart", JSON.stringify(updatedCart));
    };

    const removeFromCart = (productId) => {
        const updatedCart = cartItems.filter(item => item.uid !== productId);
        setCartItems(updatedCart);
        localStorage.setItem("cart", JSON.stringify(updatedCart));
    };

    return (
        <CartContext.Provider value={{ 
            cartItems, 
            isOpenCart,
            setIsOpenCart,
            addToCart, 
            updateQuantity,
            removeFromCart,
            openCart,
        }}>
            {children}
        </CartContext.Provider>
    );
};
